import React, {memo, useCallback, useEffect} from 'react';
import './index.scss';
import SimpleImageSlider from "react-simple-image-slider";
import {useHistory} from "react-router-dom";
import {MediaFileTag} from '../../store/ui/state';
import {useFilterSelector} from "../../hooks/filter-selector";
import {useOrientation} from "../../hooks/orientation";
import {Configs} from "../../configs";
import {useDispatch} from "react-redux";
import {setScreenSaverStatusAction} from "../../store/control/actions";
import {useRPC} from "../../hooks/rpc";
import {onClickHandler} from "../../utils/onclick";

export const SliderScreen = memo(function SliderScreen() {
    const dispatch = useDispatch();
    const [rpc] = useRPC();
    const history = useHistory();
    const orientation = useOrientation('horizontal');
    const backgroundList = useFilterSelector(state => state.ui.mediaFileList, media => media.type === 'background' && media.tags.includes(orientation as MediaFileTag), [orientation]);
    const images = []
    backgroundList.map(img => (
        images.push(Configs.IMAGE_PREFIX + "/bc" + img.url)
    ));

    const hideSlider = useCallback(() => {
        dispatch(setScreenSaverStatusAction(''))
        history.push('/')
        rpc.touchEvent().then();
    }, [rpc, history, dispatch]);

    return (
        <div className="slider-container">
            <SimpleImageSlider
                useGPURender={false}
                startIndex={0}
                showNavs={false}
                width={orientation === "vertical" ? 600 : 1024}
                height={orientation === "vertical" ? 1024 : 600}
                images={images}
                showBullets={false}
                loop={true}
                autoPlay={true}
                autoPlayDelay={20}
                {...onClickHandler(hideSlider)}
            />

        </div>
    );
});
